import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["formats"],
  _excluded2 = ["locale", "format"],
  _excluded3 = ["locale", "format"],
  _excluded4 = ["locale", "format"],
  _excluded5 = ["locale"],
  _excluded6 = ["locale"],
  _excluded7 = ["locale"];
import { writable as e, derived as n } from "svelte/store";
import t from "deepmerge";
import o from "intl-messageformat";
var i = {},
  r = function r(e, n, t) {
    return t ? (n in i || (i[n] = {}), e in i[n] || (i[n][e] = t), t) : t;
  },
  s = function s(e, n) {
    if (null == n) return;
    if (n in i && e in i[n]) return i[n][e];
    var t = E(n);
    for (var _o = 0; _o < t.length; _o++) {
      var _i = c(t[_o], e);
      if (_i) return r(e, n, _i);
    }
  };
var l;
var a = e({});
function u(e) {
  return e in l;
}
function c(e, n) {
  if (!u(e)) return null;
  var t = function (e) {
    return l[e] || null;
  }(e);
  return function (e, n) {
    if (null == n) return;
    if (n in e) return e[n];
    var t = n.split(".");
    var o = e;
    for (var _e = 0; _e < t.length; _e++) if ("object" == typeof o) {
      if (_e > 0) {
        var _n = t.slice(_e, t.length).join(".");
        if (_n in o) {
          o = o[_n];
          break;
        }
      }
      o = o[t[_e]];
    } else o = void 0;
    return o;
  }(t, n);
}
function m(e) {
  for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    n[_key - 1] = arguments[_key];
  }
  delete i[e], a.update(function (o) {
    return o[e] = t.all([o[e] || {}].concat(n)), o;
  });
}
var f = n([a], function (_ref) {
  var _ref2 = _slicedToArray(_ref, 1),
    e = _ref2[0];
  return Object.keys(e);
});
a.subscribe(function (e) {
  return l = e;
});
var d = {};
function g(e) {
  return d[e];
}
function h(e) {
  return null != e && E(e).some(function (e) {
    var n;
    return null === (n = g(e)) || void 0 === n ? void 0 : n.size;
  });
}
function w(e, n) {
  var t = Promise.all(n.map(function (n) {
    return function (e, n) {
      d[e].delete(n), 0 === d[e].size && delete d[e];
    }(e, n), n().then(function (e) {
      return e.default || e;
    });
  }));
  return t.then(function (n) {
    return m.apply(void 0, [e].concat(_toConsumableArray(n)));
  });
}
var p = {};
function b(e) {
  if (!h(e)) return e in p ? p[e] : Promise.resolve();
  var n = function (e) {
    return E(e).map(function (e) {
      var n = g(e);
      return [e, n ? _toConsumableArray(n) : []];
    }).filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        e = _ref4[1];
      return e.length > 0;
    });
  }(e);
  return p[e] = Promise.all(n.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      e = _ref6[0],
      n = _ref6[1];
    return w(e, n);
  })).then(function () {
    if (h(e)) return b(e);
    delete p[e];
  }), p[e];
}
function y(e, n) {
  g(e) || function (e) {
    d[e] = new Set();
  }(e);
  var t = g(e);
  g(e).has(n) || (u(e) || a.update(function (n) {
    return n[e] = {}, n;
  }), t.add(n));
}
function v(_ref7) {
  var e = _ref7.locale,
    n = _ref7.id;
  console.warn("[svelte-i18n] The message \"".concat(n, "\" was not found in \"").concat(E(e).join('", "'), "\".").concat(h(D()) ? "\n\nNote: there are at least one loader still registered to this locale that wasn't executed." : ""));
}
var M = {
  fallbackLocale: null,
  loadingDelay: 200,
  formats: {
    number: {
      scientific: {
        notation: "scientific"
      },
      engineering: {
        notation: "engineering"
      },
      compactLong: {
        notation: "compact",
        compactDisplay: "long"
      },
      compactShort: {
        notation: "compact",
        compactDisplay: "short"
      }
    },
    date: {
      short: {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
      },
      medium: {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      long: {
        month: "long",
        day: "numeric",
        year: "numeric"
      },
      full: {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      }
    },
    time: {
      short: {
        hour: "numeric",
        minute: "numeric"
      },
      medium: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      },
      long: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      },
      full: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      }
    }
  },
  warnOnMissingMessages: !0,
  handleMissingMessage: void 0,
  ignoreTag: !0
};
function j() {
  return M;
}
function O(e) {
  var n = e.formats,
    t = _objectWithoutProperties(e, _excluded),
    o = e.initialLocale || e.fallbackLocale;
  return t.warnOnMissingMessages && (delete t.warnOnMissingMessages, null == t.handleMissingMessage ? t.handleMissingMessage = v : console.warn('[svelte-i18n] The "warnOnMissingMessages" option is deprecated. Please use the "handleMissingMessage" option instead.')), Object.assign(M, t, {
    initialLocale: o
  }), n && ("number" in n && Object.assign(M.formats.number, n.number), "date" in n && Object.assign(M.formats.date, n.date), "time" in n && Object.assign(M.formats.time, n.time)), x.set(o);
}
var $ = e(!1);
var k;
var T = e(null);
function L(e) {
  return e.split("-").map(function (e, n, t) {
    return t.slice(0, n + 1).join("-");
  }).reverse();
}
function E(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : j().fallbackLocale;
  var t = L(e);
  return n ? _toConsumableArray(new Set([].concat(_toConsumableArray(t), _toConsumableArray(L(n))))) : t;
}
function D() {
  return null != k ? k : void 0;
}
T.subscribe(function (e) {
  k = null != e ? e : void 0, "undefined" != typeof window && null != e && document.documentElement.setAttribute("lang", e);
});
var x = _objectSpread(_objectSpread({}, T), {}, {
    set: function set(e) {
      if (e && function (e) {
        if (null == e) return;
        var n = E(e);
        for (var _e2 = 0; _e2 < n.length; _e2++) {
          var _t = n[_e2];
          if (u(_t)) return _t;
        }
      }(e) && h(e)) {
        var _j = j(),
          _n2 = _j.loadingDelay;
        var _t2;
        return "undefined" != typeof window && null != D() && _n2 ? _t2 = window.setTimeout(function () {
          return $.set(!0);
        }, _n2) : $.set(!0), b(e).then(function () {
          T.set(e);
        }).finally(function () {
          clearTimeout(_t2), $.set(!1);
        });
      }
      return T.set(e);
    }
  }),
  N = function N(e, n) {
    var t = e.split("&").find(function (e) {
      return 0 === e.indexOf("".concat(n, "="));
    });
    return t ? t.split("=").pop() : null;
  },
  A = function A(e, n) {
    var t = n.exec(e);
    return t && t[1] || null;
  },
  P = function P(e) {
    return "undefined" == typeof window ? null : A(window.location.hostname, e);
  },
  S = function S(e) {
    return "undefined" == typeof window ? null : A(window.location.pathname, e);
  },
  z = function z() {
    return "undefined" == typeof window ? null : window.navigator.language || window.navigator.languages[0];
  },
  F = function F(e) {
    return "undefined" == typeof window ? null : N(window.location.search.substr(1), e);
  },
  I = function I(e) {
    return "undefined" == typeof window ? null : N(window.location.hash.substr(1), e);
  },
  Z = function Z(e) {
    var n = Object.create(null);
    return function (t) {
      var o = JSON.stringify(t);
      return o in n ? n[o] : n[o] = e(t);
    };
  },
  C = function C(e, n) {
    var _j2 = j(),
      t = _j2.formats;
    if (e in t && n in t[e]) return t[e][n];
    throw new Error("[svelte-i18n] Unknown \"".concat(n, "\" ").concat(e, " format."));
  },
  G = Z(function (_ref8) {
    var e = _ref8.locale,
      n = _ref8.format,
      t = _objectWithoutProperties(_ref8, _excluded2);
    if (null == e) throw new Error('[svelte-i18n] A "locale" must be set to format numbers');
    return n && (t = C("number", n)), new Intl.NumberFormat(e, t);
  }),
  J = Z(function (_ref9) {
    var e = _ref9.locale,
      n = _ref9.format,
      t = _objectWithoutProperties(_ref9, _excluded3);
    if (null == e) throw new Error('[svelte-i18n] A "locale" must be set to format dates');
    return n ? t = C("date", n) : 0 === Object.keys(t).length && (t = C("date", "short")), new Intl.DateTimeFormat(e, t);
  }),
  U = Z(function (_ref10) {
    var e = _ref10.locale,
      n = _ref10.format,
      t = _objectWithoutProperties(_ref10, _excluded4);
    if (null == e) throw new Error('[svelte-i18n] A "locale" must be set to format time values');
    return n ? t = C("time", n) : 0 === Object.keys(t).length && (t = C("time", "short")), new Intl.DateTimeFormat(e, t);
  }),
  V = function V() {
    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref11$locale = _ref11.locale,
      e = _ref11$locale === void 0 ? D() : _ref11$locale,
      n = _objectWithoutProperties(_ref11, _excluded5);
    return G(_objectSpread({
      locale: e
    }, n));
  },
  _ = function _() {
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref12$locale = _ref12.locale,
      e = _ref12$locale === void 0 ? D() : _ref12$locale,
      n = _objectWithoutProperties(_ref12, _excluded6);
    return J(_objectSpread({
      locale: e
    }, n));
  },
  q = function q() {
    var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref13$locale = _ref13.locale,
      e = _ref13$locale === void 0 ? D() : _ref13$locale,
      n = _objectWithoutProperties(_ref13, _excluded7);
    return U(_objectSpread({
      locale: e
    }, n));
  },
  B = Z(function (e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D();
    return new o(e, n, j().formats, {
      ignoreTag: j().ignoreTag
    });
  }),
  H = function H(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var t, o, i, r;
    var l = n;
    "object" == typeof e && (l = e, e = l.id);
    var _l = l,
      a = _l.values,
      _l$locale = _l.locale,
      u = _l$locale === void 0 ? D() : _l$locale,
      c = _l.default;
    if (null == u) throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");
    var m = s(e, u);
    if (m) {
      if ("string" != typeof m) return console.warn("[svelte-i18n] Message with id \"".concat(e, "\" must be of type \"string\", found: \"").concat(typeof m, "\". Gettin its value through the \"$format\" method is deprecated; use the \"json\" method instead.")), m;
    } else m = null !== (r = null !== (i = null === (o = (t = j()).handleMissingMessage) || void 0 === o ? void 0 : o.call(t, {
      locale: u,
      id: e,
      defaultValue: c
    })) && void 0 !== i ? i : c) && void 0 !== r ? r : e;
    if (!a) return m;
    var f = m;
    try {
      f = B(m, u).format(a);
    } catch (n) {
      n instanceof Error && console.warn("[svelte-i18n] Message \"".concat(e, "\" has syntax error:"), n.message);
    }
    return f;
  },
  K = function K(e, n) {
    return q(n).format(e);
  },
  Q = function Q(e, n) {
    return _(n).format(e);
  },
  R = function R(e, n) {
    return V(n).format(e);
  },
  W = function W(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : D();
    return s(e, n);
  },
  X = n([x, a], function () {
    return H;
  }),
  Y = n([x], function () {
    return K;
  }),
  ee = n([x], function () {
    return Q;
  }),
  ne = n([x], function () {
    return R;
  }),
  te = n([x, a], function () {
    return W;
  });
function oe(e) {
  var n;
  var t = e.subscribe(function (e) {
      return n = e;
    }),
    o = function o() {
      return n.apply(void 0, arguments);
    };
  return o.freeze = t, o;
}
function ie(e) {
  return e;
}
function re(e) {
  return b(e || D() || j().initialLocale);
}
export { X as _, m as addMessages, ee as date, ie as defineMessages, a as dictionary, X as format, _ as getDateFormatter, I as getLocaleFromHash, P as getLocaleFromHostname, z as getLocaleFromNavigator, S as getLocaleFromPathname, F as getLocaleFromQueryString, B as getMessageFormatter, V as getNumberFormatter, q as getTimeFormatter, O as init, $ as isLoading, te as json, x as locale, f as locales, ne as number, y as register, X as t, Y as time, oe as unwrapFunctionStore, re as waitLocale };